
import Vue from 'vue';
import Callout, { AllowedTypes } from '@/components/Callout.vue';
import { WarningLevels, DocumentsStatus } from '@/enum/postgradStudentDocuments.enum';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { CourseModel } from '@descomplica/dex-models';
import StudentDocumentRequestService from '@/helpers/postgradStudentDocuments/request';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

export default Vue.extend({
  components: {
    Callout,
  },
  data() {
    return {
      showCallout: true,
      warningLevels: WarningLevels,
      statuses: DocumentsStatus,
      allowedCalloutTypes: AllowedTypes,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    status(): DocumentsStatus {
      return this.$store.getters.studentDocumentsStatusByCourseId(this.currentCourse.id).status;
    },
    warningLevel(): WarningLevels {
      return this.$store.getters.studentDocumentsStatusByCourseId(this.currentCourse.id)
        .delayWarningLevel;
    },
    isUserInTrialCourse(): boolean {
      return !!this.$store.getters.trialByDescomplicaCourseId(this.currentChimeraCourse._id);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    $route(to, from) {
      this.showCallout = true;
    },
  },
  methods: {
    closeCallout() {
      Analytics.trackEvent(EVENT_LABELS.documentToastClosed, {
        status: DocumentsStatus[this.status],
        warning_level: WarningLevels[this.warningLevel],
      });

      this.showCallout = false;
    },
    isExpectedWarningLevel(level: WarningLevels): boolean {
      return this.warningLevel === level;
    },
    isExpectedStatus(status: DocumentsStatus): boolean {
      return this.status === status;
    },
    openJacadPlatform(): void {
      Analytics.trackEvent(EVENT_LABELS.linkClicked, {
        status: DocumentsStatus[this.status],
        warning_level: WarningLevels[this.warningLevel],
      });

      StudentDocumentRequestService.executeSSO({
        redirectToDocumentsPage: true,
        descomplicaCourseId: this.currentCourse.descomplicaCourseId,
      });
    },
  },
});
